import React, { FC, useCallback } from 'react';
import { Box } from 'rebass/styled-components';
import { useDropzone } from 'react-dropzone';
import DropHint from 'components/shell/DropHint';

type Props = {
  upload(file: File): void;
  allowClick?: boolean;
};

const AssetDropzone: FC<Props> = ({ upload, children, allowClick = false }) => {
  const onDrop = useCallback(
    (acceptedFiles: []) => {
      acceptedFiles.forEach((file) => {
        upload(file);
      });
    },
    [upload],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: onDrop,
    multiple: true,
    noClick: !allowClick,
  });

  return (
    <Box
      {...getRootProps()}
      width={1 / 1}
      height={'100%'}
      overflow={'hidden'}
      overflowY="auto"
      bg={'transparent'}
      sx={{
        position: 'relative',
        ':focus': { outline: 'none' },
      }}
    >
      <DropHint text="Drop files here to add project assets" active={isDragActive} />
      <input {...getInputProps()} />
      {children}
    </Box>
  );
};

export default AssetDropzone;
